import { Controller } from "@hotwired/stimulus"

// Unzer rejects a second refund of the same amount on one payment as a
// duplicate transaction, so bookings that cost the same cannot be canceled
// one after another. This lets the booking service select several bookings
// and cancel them in a single request.
export default class extends Controller {
  static targets = ["booking", "button"]

  connect() {
    this.update()
  }

  update() {
    const ids = this.bookingTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.dataset.bookingId)

    this.buttonTargets.forEach((button) => {
      button.classList.toggle("disabled", ids.length === 0)
      button.dataset.variables = JSON.stringify({
        path: this.pathFor(button, ids),
        body: this.bodyFor(button, ids),
      })
    })
  }

  pathFor(button, ids) {
    const url = new URL(button.dataset.path, window.location.origin)
    ids.forEach((id) => url.searchParams.append("booking_ids[]", id))
    return `${url.pathname}${url.search}`
  }

  bodyFor(button, ids) {
    const bookings = ids.length === 1 ? "1 Buchung" : `${ids.length} Buchungen`

    return button.dataset.path.includes("refund=true")
      ? `${bookings} stornieren und Refund erstatten?`
      : `${bookings} ohne Refund stornieren?`
  }
}
